import React, { Component } from 'react';
import {connect} from 'react-redux';
import moment from 'moment-timezone';
import {doCall} from '../actions/call';
import {callTimer} from '../utils/utils';
import "../agent/Styles/darktheme.css";
import "../agent/Styles/blacktheme.css";
import "../agent/Styles/highContrast.css";

class AgentQueueRow extends Component {
	constructor(props) {
    super(props);
    this.state = {
      searchFilter: ''
    };
  }

  componentWillMount(){
    if(this.props.item.linkedid && this.props.item.linkedid){
      this.showTimer(this.props.item.linkedid, this.props.item.startTime);
    }
  }

  componentWillUnmount(){
    if(this.state[`timer${this.props.item.linkedid}`]){
      clearInterval(this[`timer${this.props.item.linkedid}`]);
    }
  }

	// check for user availability. if available then makes call
	// Es posible que no se use nunca.
	handlePhoneClick = (e) => {
		const idArr = e.target.id.split('_');
		const type = idArr[0];
		const id = idArr[1];
		const { extension, busy } = this.props[type].find(item => item.id == id);
		if(!busy){
            this.makeCall(extension);
		}
	}

	makeCall = (phoneNumber) => {
		const payload = {
			phoneNumber,
			internalCall: true
		};
		this.props.doCall(payload);
	}

	showTimer = (id, startTime) => {
		if(!this[`timer${id}`]){
      const currentTime = moment();
      const startTimeObj = moment(startTime * 1000);
			let sec = currentTime.diff(startTimeObj, 'seconds');
			sec = Math.max(0, sec);
	    this[`timer${id}`] = setInterval(() => {
	      sec = moment().diff(startTimeObj, 'seconds');
				sec = Math.max(0, sec);
	      this.setState({
	        [`timer${id}`]: callTimer(sec)
	      });
	    }, 1000);
		}
  }

	render() {
    const {
			item,
		} = this.props;
		return (
      <div style={{width:'100%', display: 'inline-flex'}}>
        <div className={`queueCallRow${this.props.theme}`} style={{width: '35%', fontSize: 10}}>
          <span>{item.callerid}</span>
        </div>
		<div className={`queueCallRow${this.props.theme}`} style={{width: '35%', fontSize: 10}}>
          <span>{item.agent_name}</span>
        </div>
        <div className={`queueCallRow${this.props.theme}`} style={{width: '30%', fontSize: 10}}>
          <span>{this.state[`timer${item.linkedid}`]}</span>
        </div>
      </div>
	  );
	}
}

function mapStateToProps  (state) {
    return {
				translations: state.languages.translations,
				selectedLanguage: state.languages.selectedLanguage,			
				theme: state.common.theme,
    };
}

const mapDispatchToProps = {
	doCall
}

export default connect(mapStateToProps, mapDispatchToProps)(AgentQueueRow);



// WEBPACK FOOTER //
// ./src/agent/AgentQueueRow.js